import React, { useEffect, useState } from 'react'
import { createPortal } from 'react-dom'
import { withRouter, Prompt } from 'react-router'
import { connect } from 'react-redux'
import { closeTask } from 'state/actions'

import SingleTask from './single-task'

export default withRouter(connect(state => ({
    currentTaskId: state.account.currentTaskId
}), {
    closeTask
})(({
    taskId,
    close,
    project,
    applicableUsers,
    location,
    history,
    closeTask,
    currentTaskId
}) => {
    const [visible, setVisible] = useState(false)
    const [isInputDirty, setIsInputDirty] = useState(false)

    useEffect(() => {
        setTimeout(() => {
            setVisible(true)
        }, 10)
    }, [])

    const goBack = () => {
        const _goBack = () => {
            setVisible(false)

            // Only give up currentTaskId if it's ours - another SingleTask may still
            // be mounted behind this modal, and nulling it empties its file list.
            if (currentTaskId === taskId) {
                closeTask()
            }
    
            return setTimeout(() => {
                if (close) {
                    close()
                } else {
                    let tempUrl = location.pathname
                    let to = tempUrl.lastIndexOf('/')
    
                    to = to == -1 ? tempUrl.length : to + 1
    
                    tempUrl = tempUrl.substring(0, to)
    
                    history.push(tempUrl)
                }
            }, 300)
        }

        if(!isInputDirty){
            return _goBack()
        }

        if(isInputDirty){
            if (window.confirm(`Looks like you have an unposted comment. Leave anyway?`)) {
                _goBack()
              }
        }
    }

    const singleTaskPortalParent = document.getElementById('single-task-portal')

    if (!singleTaskPortalParent) {
        return null
    }

    return createPortal(
        <div className={`single-task-modal ${visible ? 'visible' : ''}`} onClick={goBack}>
            <main className={'single-task-modal-inner'} onClick={e => e.stopPropagation()}>
                <Prompt 
                    message={`Looks like you have an unposted comment. Leave anyway?`}
                    when={visible && isInputDirty}
                />
                <div>
                    {taskId ?
                        <SingleTask
                            currentProject={project}
                            applicableUsers={applicableUsers}
                            taskId={taskId}
                            setIsInputDirty={setIsInputDirty}
                        />
                        : null}
                </div>
            </main>
        </div>
        , singleTaskPortalParent)
}))